import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { environment } from '../../environments/environment';
import { effects, metaReducers, reducers } from '../utils/states-management/reducers/app-meta-reducer.reducer';

@NgModule({
  imports: [
    EffectsModule.forRoot(effects),
    StoreModule.forRoot(reducers, {
      metaReducers,
      initialState: {
        hydrated: false,
      },
    }),
    StoreDevtoolsModule.instrument({
      // maxAge: 25,
      // autoPause: true,
      logOnly: !environment.production,
    })
  ],
  exports: [
    StoreModule,
    EffectsModule,
    StoreDevtoolsModule
  ]
})
export class StateModule {}